// extracted by mini-css-extract-plugin
export default {"preloader":"preloader__V-8aR","preloader__done":"preloader__done__5rUdP"};